import { AuthState, authActionTypes, AuthActions } from 'Types/AuthTypes';
import * as immutable from 'immutable';

export interface AuthReducer {
  authReducer: AuthState;
}

/**
 * Redux holds only durable auth *facts*. Session state (isAuthenticated,
 * loading flags, the user profile) lives in AuthService, derived from token
 * storage — persisting derived flags is how stale-auth deadlocks happen
 * (MUS-264). See documentation/auth-architecture.md.
 */
export const defaultAuthState: AuthState = {
  tempSignUpPass: undefined,
};

export const authReducer = (state = defaultAuthState, action: AuthActions): AuthState => {
  switch (action.type) {
    case authActionTypes.CLEAR_DATA:
      return { ...defaultAuthState };
    case authActionTypes.SET_TEMP_SIGNUP_PASS:
      return immutable.merge(state, {
        tempSignUpPass: action.payload,
      });
    default:
      return state;
  }
};
